<div>
  @switch (field.type) {
    @case ('textarea') {
      <nuso-textarea-input #input [field]="field"></nuso-textarea-input>
    }
    @case ('select') {
      <nuso-select-input [field]="field"></nuso-select-input>
    }
    @case ('autocomplete') {
      <nuso-autocomplete-input [field]="field"></nuso-autocomplete-input>
    }
    @case ('search-select') {
      <nuso-search-select-input [field]="field"></nuso-search-select-input>
    }
    @case ('multiple-search-select') {
      <nuso-multiple-search-select-input [field]="field"></nuso-multiple-search-select-input>
    }
    @case ('multiple-search-select-plus') {
      <nuso-multiple-search-select-plus-input [field]="field"></nuso-multiple-search-select-plus-input>
    }
    @case ('datepicker') {
      <nuso-date-picker-input [field]="field"></nuso-date-picker-input>
    }
    @case ('daterange') {
      <nuso-date-range-input [field]="field"></nuso-date-range-input>
    }
    @case ('radio') {
      <nuso-radio-input [field]="field"></nuso-radio-input>
    }
    @case ('checkbox') {
      <nuso-checkbox-input [field]="field"></nuso-checkbox-input>
    }
    @case ('checkselect') {
      <nuso-check-select-input [field]="field"></nuso-check-select-input>
    }
    @case ('wysiwyg') {
      <nuso-wysiwyg-input [field]="field"></nuso-wysiwyg-input>
    }
    @case ('string-list') {
      <nuso-string-list-input [field]="field"></nuso-string-list-input>
    }
    @case ('hidden') {
    }
    @case ('readonly-textarea') {
      <nuso-readonly-textarea-input #input [field]="field"></nuso-readonly-textarea-input>
    }
    @case ('readonly') {
      <nuso-readonly-input [field]="field"
        (actionButtonClicked)="actionButtonClicked.emit($event)"
        (fieldClicked)="fieldClicked.emit($event)"
      ></nuso-readonly-input>
    }
    @default {
      <nuso-text-input #input [field]="field"
        (actionButtonClicked)="actionButtonClicked.emit($event)"
      ></nuso-text-input>
    }
    @case ('masked') {
      <nuso-text-input #input [field]="maskedField"
        (actionButtonClicked)="actionButtonClicked.emit($event)"
      ></nuso-text-input>
    }
    @case ('slider') {
      <nuso-slider-input [field]="field"></nuso-slider-input>
    }
    @case ('group') {
      <nuso-group-input [field]="field"></nuso-group-input>
    }
    @case ('row') {
      <nuso-row-input [field]="field"></nuso-row-input>
    }
    @case ('divider') {
      <nuso-divider-input [field]="field"></nuso-divider-input>
    }
    @case ('icon-button') {
      <nuso-icon-button-input [field]="field"></nuso-icon-button-input>
    }
    @case ('slide-toggle') {
      <nuso-slide-toggle-input [field]="field"></nuso-slide-toggle-input>
    }
    @case ('label') {
      <label>{{field.label}}</label>
    }
  }
</div>
